import { render, staticRenderFns } from "./SeoDescription.vue?vue&type=template&id=af96d75a&scoped=true&"
import script from "./SeoDescription.vue?vue&type=script&lang=js&"
export * from "./SeoDescription.vue?vue&type=script&lang=js&"
import style0 from "./SeoDescription.vue?vue&type=style&index=0&id=af96d75a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af96d75a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
